module.exports = __webpack_public_path__ + "img/validate-tutor.da11e27c.png";